import { useEffect, useState } from 'react';
import { Flex, Spin } from 'antd';

import { useAuth } from '../hooks/useAuth';

interface RequireAuthProps {
  children: React.ReactNode;
}

const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const { isAuthenticated, ensureAuthenticated } = useAuth();
  const [checking, setChecking] = useState(!isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) {
      ensureAuthenticated();
      const timer = window.setTimeout(() => setChecking(false), 1000);
      return () => window.clearTimeout(timer);
    }
    setChecking(false);
  }, [isAuthenticated, ensureAuthenticated]);

  if (!isAuthenticated || checking) {
    return (
      <Flex vertical align="center" justify="center" style={{ minHeight: '50vh' }}>
        <Spin size="large" />
      </Flex>
    );
  }

  return <>{children}</>;
};

export default RequireAuth;
